import React from "react";

/**
 * When true, Link-in-Bio / website edit forms render as right drawers
 * (`EditCarouselModalShell asDrawer`) matching website create/edit drawers.
 */
export const WebsiteLibEditAsDrawerCtx = React.createContext(false);

export function useWebsiteLibEditAsDrawer() {
  return React.useContext(WebsiteLibEditAsDrawerCtx);
}

/** Optional Remove action shown in website LiB edit drawer footers. */
export type LibEditRemoveAction = {
  /** Component display name used in the in-drawer confirm copy. */
  componentName: string;
  label?: string;
  /** Overrides the default “undo from archived” hint (e.g. permanent archive delete). */
  confirmHint?: string;
  /** Runs after the user confirms in the drawer (optimistic + persist). */
  onConfirmRemove: () => void | Promise<void>;
} | null;

export const LibEditRemoveActionCtx =
  React.createContext<LibEditRemoveAction>(null);

export function useLibEditRemoveAction() {
  return React.useContext(LibEditRemoveActionCtx);
}

/** Website LiB edit-drawer actions (status / share / copy / embed), above Remove. */
export type LibEditManagementActionKey =
  | "customize-link"
  | "copy-links"
  | "copy-shop-links"
  | "share"
  | "embed"
  | "duplicate-collection";

export type LibEditManagementAction = {
  key: LibEditManagementActionKey;
  description?: string;
  /** Instant action (copy to clipboard) — no drawer panel. */
  instant?: boolean;
  onClick: () => void;
};

export type LibEditDrawerManagement = {
  showStatus: boolean;
  statusSelectorProps?: Record<string, unknown>;
  actions: LibEditManagementAction[];
  activePanel?: LibEditManagementActionKey | null;
  onPanelBack?: () => void;
  panel?: React.ReactNode;
} | null;

export const LibEditManagementCtx =
  React.createContext<LibEditDrawerManagement>(null);

export function useLibEditManagement() {
  return React.useContext(LibEditManagementCtx);
}
